export class TripInformation {
  tripHashId: string;
  Id: string;
  locationExchangeId: string;
  startDateTime: string;
  endDateTime : string;
  startLatitude : string;
  startLongitude: string;
  endLatitude: string;
  endLongitude : boolean;
  distanceInMeters:string;
  tripReceiveDateTime: string;
  tripReadDateTime: string;
  rfidTag: string;
  licensePlate: string;
  nrOpenAnswers: number;
  isAnswered: boolean;
  prePostTripInformation: PrePostTripDetails[];
}

export class PrePostTripDetails {
  tripHashId: string;
  questionId: number;
  question: string;
  questionType: string;
  answer: string;
  answerDateTime: string;
  answerId: number;
  remark: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/trip/models/trip-information.model.ts